<template>
  <div class="count-down">
    <template v-if="hasSlot">
      <slot
        :days="timeData.days"
        :hours="timeData.hours"
        :minutes="timeData.minutes"
        :seconds="timeData.seconds"
        :milliseconds="timeData.milliseconds"
      ></slot>
    </template>
    <template v-else>
      <div class="time-con">
        <div v-for="(item, index) in formattedTime" :key="index" class="secondes-con">
          <p class="seconeds-item" v-if="index > 0">{{ `${item}` }}</p>
          <span class="colon" v-if="index == 1">:</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { isSameSecond, parseTimeData, parseFormat, raf, cancelRaf } from './utils'
import analytics from '@/utils/AnalyticsCenter'
export default {
  name: 'count-down',
  props: {
    // 是否开启毫秒级渲染
    millisecond: Boolean,
    // 倒计时时长，单位毫秒
    time: {
      type: Number,
      default: 0,
    },
    // 时间格式
    format: {
      type: String,
      default: 'HH:mm:ss',
    },
    // 是否自动开始倒计时
    autoStart: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      remain: 0,
      isKeepAlive: false,
    }
  },
  computed: {
    hasSlot() {
      return this.isSlotScope !== undefined ? this.isSlotScope : !!this.$scopedSlots.default
    },
    timeData() {
      return parseTimeData(this.remain)
    },
    formattedTime() {
      let timeArray = parseFormat(this.format, this.timeData).split(':')

      return timeArray
    },
  },
  watch: {
    time: {
      immediate: true,
      handler: 'reset',
    },
  },
  activated() {
    if (!this.isKeepAlive) {
      this.counting = true
      this.isKeepAlive = true
      this.$_tick()
    }
  },
  deactivated() {
    if (this.counting) {
      this.pause()
      this.isKeepAlive = false
    }
  },
  beforeDestroy() {
    this.pause()
  },
  methods: {
    // public methods
    // 开始
    start() {
      console.log('start')
      if (this.counting) {
        return
      }
      this.counting = true
      this.endTime = Date.now() + this.remain
      this.$_tick()
    },
    // 暂停
    pause() {
      this.counting = false
      cancelRaf(this.rafId)
    },
    // 重置
    reset() {
      console.log('reset')
      this.pause()
      this.remain = this.time
      if (this.autoStart) {
        this.start()
      }
    },
    // private methods
    $_tick() {
      if (this.millisecond) {
        this.$_microTick()
      } else {
        this.$_macroTick()
      }
    },
    $_microTick() {
      this.rafId = raf(() => {
        /* istanbul ignore if */
        // in case of call reset immediately after finish
        if (!this.counting) {
          return
        }
        this.$_setRemain(this.$_getRemain())
        if (this.remain > 0) {
          this.$_microTick()
        }
      })
    },
    $_macroTick() {
      this.rafId = raf(() => {
        /* istanbul ignore if */
        // in case of call reset immediately after finish
        if (!this.counting) {
          return
        }
        const remain = this.$_getRemain()
        if (!isSameSecond(remain, this.remain) || remain === 0) {
          this.$_setRemain(remain)
        }
        if (this.remain > 0) {
          this.$_macroTick()
        }
      })
    },
    $_getRemain() {
      return Math.max(this.endTime - Date.now(), 0)
    },
    $_setRemain(remain) {
      this.remain = remain
      if (remain === 0) {
        this.pause()
        console.log('倒计时结束--调用finish')
        analytics.logEvent('hskweb_mock_timeout')

        this.$emit('finish', 'timeEnd')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.count-down {
  color: #faae56;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  span {
    margin-right: 5px;
    &:not(:last-child) {
      &::after {
        content: ':';
        position: relative;
        top: -2px;
        margin-left: 5px;
      }
    }
  }
}
.time-con {
  display: flex;
  align-items: center;
  position: relative;
  .secondes-con {
    display: flex;
    align-items: center;
  }
  .colon {
    font-size: 24px;
    font-weight: 600;
  }
}
.seconeds-item {
  width: 36px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #fef4dd;
  background: #fff9ec;
  color: #faae56;
  font-weight: bold;
  line-height: 44px;
  text-align: center;
  margin-right: 6px;
  font-size: 24px;
}
</style>
